import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { getLandlordBuildings } from './deals-dashboard.api';

const DEFAULT_LIMIT = 500;

export const useFetchBuildings = ({
  search,
  page = 1,
  limit = DEFAULT_LIMIT,
  enabled = true,
}: {
  search?: string;
  page?: number;
  limit?: number;
  enabled?: boolean;
}) => {
  const { data, isLoading, isFetching, error } = useQuery({
    queryKey: ['landlordBuildings', search, limit, page],
    queryFn: () =>
      getLandlordBuildings({
        searchText: search,
        limit,
        page,
      }),
    staleTime: Infinity,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    enabled,
  });

  return {
    data: data?.buildings,
    isLoading,
    isFetching,
    error,
  };
};
